import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FileManagerService {
  private _httpClient = inject(HttpClient);
  private _apiUrl = environment.apiUrl;


  getAllDBFiles(ref: string) {
    let params = new HttpParams();
    params = params.set('documentId', ref);
    params = params.set('queryType', 'and');

    return this._httpClient.get(
      `${this._apiUrl}/v1/files/get-filtered-db-files`,
      { params }
    );
  }

  downloadFile(fileId: string) {


    return this._httpClient.get(
      `${this._apiUrl}/v1/files/download/${fileId}`,
      { responseType: 'blob' }
    );
  }

  deleteFile(fileId: string) {
    return this._httpClient.delete(`${this._apiUrl}/v1/files/delete/${fileId}`);
  }


  convertBytes(sizeInBytes: number): string {
    const kb = 1024;
    const mb = kb * 1024;

    if (sizeInBytes >= mb) {
      return (sizeInBytes / mb).toFixed(2) + ' MB';
    } else if (sizeInBytes >= kb) {
      return (sizeInBytes / kb).toFixed(2) + ' KB';
    } else {
      return sizeInBytes + ' Bytes';
    }
  }

  uploadFile(formData: FormData) {
    return this._httpClient.post(`${this._apiUrl}/v1/files/upload`, formData, {
      reportProgress: true,
      observe: 'events',
    });
  }
}
